var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckinline = function SvgCheckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 3.077a.835.835 0 0 1 0 1.18l-6.667 6.666a.834.834 0 0 1-1.18 0L1.412 7.59a.834.834 0 0 1 1.18-1.18l2.744 2.742 6.077-6.075a.835.835 0 0 1 1.18 0h-.003Z",
    fill: "#252525"
  })));
};
export default SvgCheckinline;